/* eslint-disable */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate(next: ActivatedRouteSnapshot) {
    let isOk: any;
    const redirectUrl = next["_routerState"]["url"];

    const token = localStorage.getItem("access_token");
    try {
      if (!token) {
        this.router
          .navigateByUrl(this.router.createUrlTree(["auth/login"]))
          .catch((error) => console.error("Oh no!", error));
        return false;
      }

      if (next.data.permiso) {
        const permisosRequeridos = next.data.permiso;
        const permisos = localStorage
          .getItem("permisos")
          .toLowerCase()
          .split("|");

        if (!permisosRequeridos.some((item) => permisos.includes(item))) {
          if (redirectUrl.includes("403") || redirectUrl.includes("404")) {
            return true;
          }

          this.router
            .navigateByUrl(this.router.createUrlTree(["403"]))
            .catch((error) => console.error("Oh no!", error));
          return false;
        }
      }

      return true;
    } catch (error) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("log_type");
      // this.router.navigate([next.data.urlToPass]);
      this.router
        .navigateByUrl(
          this.router.createUrlTree(["auth/login"], {
            queryParams: { redirectUrl },
          }),
        )
        .catch((error) => console.error("Oh no!", error));

      if (!token) {
        this.router.navigate(["/auth/login"]);
        return false;
      }
      return false;
    }
  }
}
